import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export default create(subscribeWithSelector((set) =>
{
    return {
        money: 20,
        victoryPoints: 0,
        population: 0,
        plots: 1,
        nextCost: 5,

        salary: 5,

        purchasedPlot: 2,
        plotCoords: [3,3],

        startTime: 0,
        endTime: 0,

        audioEnabled: true,

        toggleAudio: (val) =>
        {
            set({audioEnabled: val})
        },

        setPopulation: (val) =>
        {
            set({population: val})
        },

        addPopulation: (val) =>
        {
            set((state) => {return {population: state.population + val}})
        },

        addPlot: () =>
        {
            set((state) => {return {plots: state.plots + 1}})
        },
        setNextCost: (val) =>
        {
            set({nextCost: val})
        },

        setPurchasedPlot: (val) =>
        {
            set({purchasedPlot: val})
        },

        setPlotCoords: (val) =>
        {
            set({plotCoords: val})
        },

        addMoney: (val) =>
        {
            set((state) => {
                return {money: state.money + val}
            })
        },
        addVictoryPoints: (val) =>
        {
            set((state) => {
                return {victoryPoints: state.victoryPoints + val}
            })
        },

        setStartTime: (val) =>
        {
            set({startTime: val})
        },

        setSalary: (val) =>
        {
            set({salary: val})
        },

        /**
         * Phases
         * Ready, Starting, Scrolling, Buying, GameOver
         */
        phase: 'ready',

        startGame: () =>
        {
            set((state) => {
                if(state.phase == 'ready')
                    return {phase: 'starting'}
                return {}
            })
        },

        renderGame: () =>
        {
            set((state) => {
                if(state.phase == 'starting')
                    return {phase: 'scrolling', startTime: Date.now() }
                return {}
            })
        },

        startBuying: () =>
        {
            
            set((state) => {
                if(state.phase == 'scrolling')
                    return {phase: 'buying' }
                return {}
            })
        },

        endBuying: () =>
        {
            set((state) => {
                if(state.phase == 'buying')
                    return {phase: 'scrolling' }
                return {}
            })
        },

        endGame: () =>
        {
            set((state) => {
                if(state.phase != 'gameOver')
                    return {phase: 'gameOver' }
                return {}
            })
        }

    }
}))